import classNames from 'classnames';
import * as React from 'react';
import type { AspectRatio } from '~/Partials/Picture/AspectRatios';
import styles from './VideoFigure.module.css';

interface VideoFigureProps {
    children: React.ReactNode;
    caption?: string;
    ratio?: AspectRatio;
}

export const VideoFigure: React.FC<VideoFigureProps> = props => {
    const { children, caption, ratio = '16x9' } = props;

    return (
        <figure className={classNames(styles.VideoFigure, styles[`Variant--${ratio}`])}>
            <div className={styles.Media}>{children}</div>
            {caption && <figcaption>{caption}</figcaption>}
        </figure>
    );
};
